// Site-wide content configuration

export const siteInfo = {
  name: "Hood Shaw Memorial AME Zion Church",
  shortName: "Hood Shaw Memorial",
  address: "148 Wadsworth St, Providence RI",
  phone: "+1 (401) 467-3956",
  email: "greaterhoodshaw@gmail.com",
  facebook: "https://www.facebook.com/hoodshawmemorial/",
};

export const heroSlides = [
  {
    id: 1,
    title: "Welcome to Hood Shaw Memorial",
    subtitle: "A Place to Grow in Faith and Fellowship",
    buttonText: "Learn More",
    buttonLink: "#about",
    image: "https://res.cloudinary.com/ducg1tnoi/image/upload/v1733338973/church/xsjprsvumyrpqivtuovb.jpg",
  },
  {
    id: 2,
    title: "Join Us for Worship",
    subtitle: "Experience the joy of community and faith.",
    buttonText: "Reach Out",
    buttonLink: "#contact",
    image: "https://res.cloudinary.com/ducg1tnoi/image/upload/v1733343728/church/m2z6i8ark28wrgohhcqa.jpg",
  },
  {
    id: 3,
    title: "Meet our Team",
    subtitle: "Learn how we are making a difference together.",
    buttonText: "Our Pastor",
    buttonLink: "#pastor",
    image: "https://res.cloudinary.com/ducg1tnoi/image/upload/v1733338974/church/ffvrihjccyrq82a3at40.jpg",
  },
];

export const aboutContent = {
  title: "About Us",
  image: "https://res.cloudinary.com/ducg1tnoi/image/upload/v1733339320/church/qzthtv4rbtycjfx9mmzp.jpg",
  mission: `At Hood Shaw Memorial, we are committed to living out the mission of the
    African Methodist Episcopal Zion Church: to deepen our love for God and
    meet the needs of humankind by "Loving God with all our heart, soul, and
    mind, and loving our neighbor as ourselves." We strive to create a space
    where faith comes alive through engaging worship, a welcoming community,
    compassionate service, and spiritual growth for all ages. Our mission is
    to be a light in the world, spreading hope, love, and the message of
    Christ while making a meaningful impact in our community and beyond.`,
  serviceSchedule: [
    {
      name: "Sunday School",
      time: "9:00am",
    },
    {
      name: "Worship Service",
      time: "10:00am",
    },
    {
      name: "Bible Study",
      time: "Wednesdays at 6:00pm on Zoom",
    },
  ],
};

export const pastorInfo = {
  name: "Reverend Nakeida Moria Bethel-Smith",
  title: "Pastor",
  image: "https://res.cloudinary.com/ducg1tnoi/image/upload/v1733339508/church/wqx1smfiilk2aeorkwoh.jpg",
  bio: [
    `Reverend Nakeida Moria Bethel-Smith, a New York native raised in Pittsfield, MA,
    proudly serves as the Pastor at Hood-Shaw Memorial AME Zion Church in Providence, RI.
    Rev. Bethel-Smith's journey in ministry began at an early age at
    Price Memorial AME Zion Church, where she found her spiritual foundation.
    She answered the call to ministry in her early 20s, preaching her initial sermon in 2010.
    She was ordained as a deacon in 2016 and an elder in 2018,
    serving with deep dedication to the AME Zion denomination
    in the New England Annual Conference and the Boston District.`,

    `Beyond her ministry, Rev. Bethel-Smith has dedicated her professional life to advocacy and community work.
    She has extensive experience as a victim advocate, specializing in teen dating violence prevention,
    bullying education, and crisis intervention. Her passion for empowering youth extends to mentoring
    young girls of color and serving as a role model to help them find their purpose and voice.
    She has also traveled to Ghana and South Africa for service-learning projects aimed at creating meaningful impact.`,

    `Rev. Bethel-Smith earned an A.S. in Liberal Arts from Berkshire Community College and will graduate
    this winter with her B.A. in Criminal Justice, Communication, and Sociology from Westfield State University.
    She plans to pursue her Master's degree starting in the fall of 2025. She currently works as a Forensic
    Interviewer for the Worcester District Attorney's Office.`,

    `Rev. Bethel-Smith is passionate about inspiring others to anchor their souls in Christ, helping young
    adults find their place in God's house, and building a community grounded in faith, service, and love.
    Through her ministry and outreach, she continues to uplift and empower those she serves.`,
  ],
  quote: "Faith is not just a belief but a call to action. Let us walk together in love and service.",
};

export const donationInfo = {
  title: "Support Our Mission",
  description: `Your generous contributions help us serve the community, maintain our programs,
    and spread hope. Thank you for your support!`,
  cashApp: {
    handle: "$hoodshawmemorial148",
    qrCode: "https://res.cloudinary.com/ducg1tnoi/image/upload/v1733337719/church/ve7trtho53t8rb9xxboy.png",
  },
  additionalNote: "Prefer another method? Contact us directly for more ways to contribute.",
};

export const images = {
  logo: "https://res.cloudinary.com/ducg1tnoi/image/upload/v1746825790/logo_sdnblu.jpg",
};
